import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { isEmptyObject, getJCJPIDs } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { simActivationCsvFilter } from "../../../../../utils/common/csvMappings/simConnectivityCsv";
import Last7DaysView from "../../../../../views/activationSales/components/simConnectivity/last7DaysView";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";
import { triggerDashboardAudit } from "../../../../../redux/actions";

const Last7Days = (props) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const { last7DaysObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );
  let {
    url,
    csvEndPointUrl,
    isCsvActive,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerLast7DaysAPI,
    triggerLast7DaysCsvAPI,
  } = props;

  // let { last7DaysCSVData: csvData } = last7DaysCSVObj;

  let { level, jioPointId, partnerRT, retailerId, id } =
    getJCJPIDs(filterValue);

  const headers = {
    id: id,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    partnerRoleType: partnerRT,
    section: props.section,
    moduleName: props.moduleName,
    jioPointId,
    retailerId,
    level,
    dispValue: value,
  };
  useEffect(() => {
    function fetchLast7DaysData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerLast7DaysAPI(obj));
    }
    if (isEmptyObject(last7DaysObj && last7DaysObj.last7DaysData)) {
      fetchLast7DaysData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerLast7DaysAPI, headerSelectedDateFrom, headerSelectedDateTo]);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.moduleName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: props.section,
      },
    };
    triggerDashboardAudit(obj);
  };

  function fetchCsv() {
    sendAudit();

    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Mdn_Last7Days",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    let csvExporter = new ExportToCsv(options);
    function fetchLast7DaysCsvData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: csvEndPointUrl,
        },
        params: headers,
        extraData: csvEndPointUrl,
        tab: "last",
      };
      return dispatch(
        triggerLast7DaysCsvAPI(obj, (response, params) => {
          if (response?.content?.length) {
            let csvData;
            csvData = simActivationCsvFilter(
              props.filterValue.selectedJC === ""
                ? props.filterValue.selectedPartnerRoleName
                : props.filterValue.selectedJC === "ALL"
                ? props.filterValue.selectedPartnerRoleName
                : "JP",
              props.tileName.split(" ")[0].toLowerCase(),
              response.content
            );
            csvData && csvExporter.generateCsv(csvData);
          } else {
            dispatch(fetchShowAlertActivation());
            setTimeout(() => {
              dispatch(hideAlertActivation());
            }, 5000);
          }
        })
      );
    }

    if (isCsvActive === "Y") {
      fetchLast7DaysCsvData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }
  const days = [
    {
      label: "Day 1",
      value: 0,
    },
    {
      label: "Day 2",
      value: 1,
    },
    {
      label: "Day 3",
      value: 2,
    },
    {
      label: "Day 4",
      value: 3,
    },
    {
      label: "Day 5",
      value: 4,
    },
    {
      label: "Day 6",
      value: 5,
    },
    {
      label: "Day 7",
      value: 6,
    },
  ];
  const handleChange = (unit) => (event) => {
    setValue(event.target.value);
  };
  return (
    <Last7DaysView
      handleChange={handleChange}
      isCsvActive={props.isCsvActive}
      days={days}
      fetchCsv={fetchCsv}
    />
  );
};

Last7Days.propTypes = {
  url: PropTypes.string,
  content: PropTypes.object,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerLast7DaysAPI: PropTypes.func,
  triggerLast7DaysCsvAPI: PropTypes.func,
};

export default Last7Days;
